export default "__VITE_ASSET__Z_DNXlas__"